import { render, staticRenderFns } from "./EditAttrValue.vue?vue&type=template&id=c2cdf426&scoped=true"
import script from "./EditAttrValue.vue?vue&type=script&lang=js"
export * from "./EditAttrValue.vue?vue&type=script&lang=js"
import style0 from "./EditAttrValue.vue?vue&type=style&index=0&id=c2cdf426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cdf426",
  null
  
)

export default component.exports